export class SearchRequestModel<T> {
  Skip: number;
  Take: number;
  OrderByName: string;
  OrderByType: string;
  Query: T;

  constructor() { }

}
